import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const getToken = () => new URLSearchParams(window.location.search).get("token") || "";

export default function VerificarEmail() {
  const [state, setState] = useState("loading"); // loading | ok | error
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = getToken();
    (async () => {
      if (!token) return setState("error");
      try {
        await api.post("/auth/verificar-email", { token });
        setState("ok");
      } catch {
        setState("error");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md aldia-fade-up text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#3A6B56] flex items-center justify-center mx-auto">
          <ShieldCheck size={34} className="text-white" />
        </div>
        <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm mt-6">
          {state === "loading" && <p className="text-base text-[#6E7A74]">Verificando tu correo…</p>}
          {state === "ok" && (
            <div data-testid="verificar-ok">
              <CheckCircle2 size={44} className="text-[#16A34A] mx-auto" />
              <p className="text-base text-[#1C2421] mt-3">¡Tu correo ha sido verificado correctamente!</p>
            </div>
          )}
          {state === "error" && (
            <div data-testid="verificar-error">
              <XCircle size={44} className="text-[#B91C1C] mx-auto" />
              <p className="text-base text-[#1C2421] mt-3">El enlace no es válido o ha caducado.</p>
            </div>
          )}
          <Link to="/" className="inline-block mt-5 font-bold text-[#3A6B56]">Ir a la aplicación</Link>
        </div>
      </div>
    </div>
  );
}
